import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { Card, Col, Container, Image, Row } from "react-bootstrap";
import { ArrowLeftIcon, CalendarIcon, CarpetAreaIcon, Clock05Icon, DailerIcon, DownloadIcon, LandAreaIcon, PdfIcon, RedUserIcon } from "../../assets/icons";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { goBack } from "../../utils/otherHelopers";
import { routes } from "../../routes/pageRoutes";
import StatusChip from "../../components/statusChip/StatusChip";
import { useDispatch, useSelector } from "react-redux";
import { useLoader } from "../../context/LoaderContext";
import { propertyDetails } from "../../redux/slice/propertiesSlice";
import { BankIcons, formatCurrencyIndianStyle } from "../../utils/otherHelopers";
import { formatMomentDate } from "../../utils/dateHelper";
import { useToast } from "../../context/TostContext";

const ViewNpaProperties = () => {
  const { setLoading } = useLoader();
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  // const location = useLocation();
  const {id} = useParams();
  const toast = useToast();
  const details = useSelector((state) => state?.property?.propertyDetail);

  const headerPortalTarget = document.getElementById("header-portal-target");

  const renderHeaderContent = () => (
    <div className="d-flex align-items-center justify-content-between w-100">
      <div className="d-flex align-items-center gap-2">
        <button
          onClick={handleBack}
          type="button"
          className="border-0 bg-transparent p-0 d-flex align-items-center justify-content-center primary"
        >
          <ArrowLeftIcon size={22} />
        </button>
        <h4 className="fw-semibold mb-0 text-primary fs-lg">
          Details
        </h4>
      </div>
    </div>
  );
  useEffect(() => {
    if (id) {
      setLoading(true);
      dispatch(propertyDetails({ id }))
        .then(() => {
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [dispatch, id, setLoading]);

  const downloadPDF = async () => {
    if (!details?.property_document) {
      toast.error("No document available for Download");
      return;
    }

    try {
      setLoading(true);

      const token = localStorage.getItem("auth-token"); // Assuming token is stored here
      // const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:3001/v1";
      const downloadUrl = `${process.env.REACT_APP_BASE_URL}/npa-properties/download/${id}`;

      const response = await fetch(downloadUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch the file from proxy.");
      }
      const blob = await response.blob();

      // Create a Blob URL and trigger the download
      const blobUrl = URL.createObjectURL(blob);
      const anchor = document.createElement("a");
      anchor.href = blobUrl;
      anchor.download = details ? `${details?.borrower_names}.pdf` : "Downloaded Pdf.pdf";
      document.body.appendChild(anchor); // Append the anchor to the body
      anchor.click(); // Trigger the download
      document.body.removeChild(anchor); // Remove the anchor after download
      URL.revokeObjectURL(blobUrl); // Release the Blob URL
      setLoading(false);
      toast.success("Document downloaded successfully");
    } catch (error) {
      setLoading(false);
      toast.error("Error downloading PDF:", error);
      console.error("Error downloading PDF:", error);
    } finally {
      // setShowToast(true);
      setLoading(false);
    }
  };

  // Back button (for navigating to a listing page)
  const handleBack = () => {
    goBack(navigate, location, routes.npaProperties);
  }

  return (
    <>
      {headerPortalTarget && createPortal(renderHeaderContent(), headerPortalTarget)}
      <Container fluid className="px-0">
        <Row className="mt-4 gy-4 mt-0">
          <Col xl={12} xxl={8}>
            <div className="grid column-gap-4 column-gap-xxl-0">
              <Card className="rounded-2 g-col-12 g-col-xl-6 g-col-xxl-12 p-4 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 bg-transparent border-0 common-card-header">
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <h5 className="fw-medium npa-details">
                      {/* Shivam Plaza Commercial Hub */}
                      {`${details?.asset_category?.name} for Auction at ${details?.city ? details?.city : ""}`}
                    </h5>
                    <StatusChip
                      pill
                      bg={
                        details?.status === "upcoming"
                          ? "warning"
                          : details?.status === "live"
                            ? "success"
                            : details?.status === "expired"
                              ? "danger"
                              : ""
                      }
                      title={details?.status}
                      className="text-capitalize"
                    />
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <div className="d-flex align-items-center gap-2 text-decoration-none mb-3 card-profile">
                    <div className="d-flex align-items-center justify-content-center flex-shrink-1">
                      {details?.bank_user?.bank?.logo?.url ? (
                        <img
                          src={details.bank_user.bank.logo.url}
                          alt={details.bank_user.bank.name}
                          style={{
                            width: 40,
                            height: 40,
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <div className="rounded-circle d-flex align-items-center justify-content-center user-icon">
                          {BankIcons(details?.bank_user?.bank?.name || "NA")}
                        </div>
                      )}
                    </div>

                    <p className="ms-1 p-light mb-0">
                      {details?.bank_user?.bank?.name || "NA"}
                    </p>
                  </div>
                  <div className="d-flex flex-column gap-3 card-content">
                    <div>
                      <p className="mb-1 p-light mb-3">
                        Possession Type{" "}
                        <span className="fw-medium">
                          {details?.possession_type
                            ? details?.possession_type?.name
                            : "-"}
                        </span>
                      </p>
                      <p className="mb-3">
                        <StatusChip
                          pill
                          bg="success"
                          title={
                            details?.possession_type
                              ? details?.possession_type?.name
                              : "-"
                          }
                          className="text-capitalize"
                        />
                        <StatusChip
                          pill
                          bg="success"
                          title={
                            details?.property_type
                              ? details?.property_type?.name
                              : "-"
                          }
                          className="text-capitalize mx-2"
                        />
                      </p>
                      <h6 className="mb-2 npa-details">About</h6>
                      <p className="mb-1 fw-normal mb-3">
                        {details?.address_line_1
                          ? details?.address_line_1
                          : "-"}
                      </p>
                      <div className="d-flex flex-column flex-xxl-row gap-3 w-100">
                        <div className="rounded border p-3 flex-grow-1">
                          {/* Styled div */}
                          <Row>
                            <Col
                              xs={6}
                              className="d-flex flex-column align-items-center border-end"
                            >
                              <p className="mb-1 p-light">Created date</p>
                              <h6 className="npa-details">
                                {details?.created_at
                                  ? formatMomentDate(details?.created_at, 
                                    "DD-MM-YYYY"
                                  )
                                  : "-"}
                              </h6>
                            </Col>
                            <Col
                              xs={6}
                              className="d-flex flex-column align-items-center"
                            >
                              <p className="mb-1 p-light">Created time</p>
                              <h6 className="npa-details">
                                {" "}
                                {details?.created_at
                                  ? formatMomentDate(details?.created_at, 
                                    "hh:mm A"
                                  )
                                  : "-"}
                              </h6>
                            </Col>
                          </Row>
                        </div>
                        {/* Second Box */}
                        <div className="rounded border p-3 flex-grow-1">
                          {" "}
                          {/* Styled div */}
                          <Row>
                            <Col
                              xs={6}
                              className="d-flex flex-column align-items-center border-end"
                            >
                              <p className="mb-1 p-light">Updated date</p>
                              <h6 className="npa-details">
                                {details?.updated_at
                                  ? formatMomentDate(details?.updated_at, 
                                    "DD-MM-YYYY"
                                  )
                                  : "-"}
                              </h6>
                            </Col>
                            <Col
                              xs={6}
                              className="d-flex flex-column align-items-center"
                            >
                              <p className="mb-1 p-light">Updated time</p>
                              <h6 className="npa-details">
                                {details?.updated_at
                                  ? formatMomentDate(details?.updated_at, 
                                    "hh:mm A"
                                  )
                                  : "-"}
                              </h6>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <Card className="rounded-2 g-col-12 g-col-xl-6 g-col-xxl-12 p-4 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <h6 className="mb-2 npa-details">Bank Details</h6>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <div className="d-flex align-items-center gap-2 text-decoration-none mb-4 card-profile">
                    <div className="d-flex align-items-center justify-content-center flex-shrink-1">
                      {details?.bank_user?.bank?.logo?.url ? (
                        <img
                          src={details.bank_user.bank.logo.url}
                          alt={details.bank_user.bank.name}
                          style={{
                            width: 40,
                            height: 40,
                            objectFit: "contain",
                          }}
                        />
                      ) : (
                        <div className="rounded-circle d-flex align-items-center justify-content-center user-icon">
                          {BankIcons(details?.bank_user?.bank?.name || "NA")}
                        </div>
                      )}
                    </div>

                    <div className="d-flex flex-column">
                      <h6 className="npa-details">
                        {details?.bank_user?.bank ? details?.bank_user?.bank?.name : "NA"}
                      </h6>
                      <p className="p-light">Bank Name</p>
                    </div>
                  </div>

                  <div className="d-flex flex-column gap-3 card-content">
                    <div className="d-flex align-items-center justify-content-between border-bottom ">
                      <p className="p-extra-light mb-2">Branch Name</p>
                      <p className="p-dark mb-2">
                        {details?.bank_user ? details?.bank_user?.branch?.name : "-"}
                      </p>
                    </div>
                    <div className="d-flex align-items-center justify-content-between border-bottom">
                      <p className="p-extra-light mb-2">Branch City</p>
                      <p className="p-dark mb-2">
                        {details?.bank_user ? details?.bank_user?.branch?.city : "-"}
                      </p>
                    </div>

                    <div className="d-flex flex-column flex-xxl-row gap-3 w-100">
                      {/* First Box */}
                      <div className="rounded border p-3 flex-grow-1">
                        {" "}
                        {/* Styled div */}
                        <Row>
                          <Col
                            xs={6}
                            className="d-flex flex-column align-items-center border-end"
                          >
                            <p className="mb-1 p-light">EMD</p>
                            <h6 className="npa-details">
                              {details?.emd
                                ? `₹ ${formatCurrencyIndianStyle(details?.emd)}`
                                : "-"}
                            </h6>
                          </Col>
                          <Col
                            xs={6}
                            className="d-flex flex-column align-items-center"
                          >
                            <p className="mb-1 p-light">Reserve Price</p>
                            <h6 className="npa-details">
                              {details?.reserve_price
                                ? `₹ ${formatCurrencyIndianStyle(
                                  details?.reserve_price
                                )}`
                                : "-"}
                            </h6>
                          </Col>
                        </Row>
                      </div>
                      {/* Second Box */}
                      <div className="rounded border p-3 flex-grow-1">
                        {/* Styled div */}
                        <Row>
                          <Col
                            xs={6}
                            className="d-flex flex-column align-items-center border-end"
                          >
                            <p className="mb-1 p-light">Minimum Increment</p>
                            <h6 className="npa-details">
                              {details?.min_increment
                                ? `₹ ${formatCurrencyIndianStyle(
                                  details?.min_increment
                                )}`
                                : "-"}
                            </h6>
                          </Col>
                          <Col
                            xs={6}
                            className="d-flex flex-column align-items-center"
                          >
                            <p className="mb-1 p-light">Amount Outstanding</p>
                            <h6 className="npa-details">
                              {details?.amount_outstanding
                                ? `₹ ${formatCurrencyIndianStyle(
                                  details?.amount_outstanding
                                )}`
                                : "-"}
                            </h6>
                          </Col>
                        </Row>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <Card className="rounded-2 g-col-12 g-col-lg-6 g-col-xxl-12 p-4 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <h5 className="fw-medium text-capitalize">
                      Auction Details
                    </h5>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2">
                    <div className="g-col-12 g-col-xl-6 g-col-xxl-3">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className="rounded-5 d-flex align-items-center justify-content-center status-icon">
                          <CalendarIcon
                            width={22}
                            height={22}
                            color="#9F2F48"
                            strokeWidth="1.5"
                          />
                        </div>
                        <div>
                          <h6 className="npa-details">
                            {details?.auction_start_time
                              ? formatMomentDate(details?.auction_start_time, 
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </h6>
                          <span className="text-capitalize">
                            Auction Start Date
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="g-col-12 g-col-xl-6 g-col-xxl-3">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className="rounded-5 d-flex align-items-center justify-content-center status-icon primary">
                          <Clock05Icon size={22} />
                        </div>
                        <div>
                          <h6 className="npa-details">
                            {details?.auction_start_time
                              ? formatMomentDate(details?.auction_start_time, 
                                "hh:mm A"
                              )
                              : "-"}
                          </h6>
                          <span className="text-capitalize">
                            Auction Start Time
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="g-col-12 g-col-xl-6 g-col-xxl-3">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className="rounded-5 d-flex align-items-center justify-content-center status-icon">
                          <CalendarIcon
                            width={22}
                            height={22}
                            color="#9F2F48"
                            strokeWidth="1.5"
                          />
                        </div>
                        <div>
                          <h6 className="npa-details">
                            {details?.auction_end_time
                              ? formatMomentDate(details?.auction_end_time, 
                                "DD-MM-YYYY"
                              )
                              : "-"}
                          </h6>
                          <span className="text-capitalize">
                            Auction End Date
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="g-col-12 g-col-xl-6 g-col-xxl-3">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className="rounded-5 d-flex align-items-center justify-content-center status-icon primary">
                          <Clock05Icon size={22} />
                        </div>
                        <div>
                          <h6 className="npa-details">
                            {details?.auction_end_time
                              ? formatMomentDate(details?.auction_end_time, 
                                "hh:mm A"
                              )
                              : "-"}
                          </h6>
                          <span className="text-capitalize">
                            Auction End Time
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <Card className="rounded-2 g-col-12 g-col-lg-6 g-col-xxl-12 p-4 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <h5 className="fw-medium text-capitalize">
                      Contact Details
                    </h5>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2">
                    <div className="g-col-12 g-col-xl-6 g-col-xxl-3">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className="rounded-2 d-flex align-items-center justify-content-center status-icon">
                          <i>
                            <RedUserIcon size={22} />
                          </i>
                        </div>
                        <div>
                          <h6 className="npa-details">
                            {details?.contact_name
                              ? details?.contact_name
                              : "-"}
                          </h6>
                          <span className="text-capitalize">Name</span>
                        </div>
                      </div>
                    </div>
                    <div className="g-col-12 g-col-xl-6 g-col-xxl-3">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className="rounded-2 d-flex align-items-center justify-content-center status-icon primary">
                          <DailerIcon size={22} />
                        </div>
                        <div>
                          <h6 className="npa-details">
                            {details?.contact_number
                              ? details?.contact_number
                              : "-"}
                          </h6>
                          <span className="text-capitalize">Phone</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <Card className="rounded-2 g-col-12 p-4 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 bg-transparent border-0 common-card-header">
                  <div>
                    <h5 className="fw-medium text-capitalize mb-1">
                      Downloads
                    </h5>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <div className="d-flex align-items-center justify-content-between w-100">
                    <p>
                      <PdfIcon
                        width={22}
                        height={22}
                        color="#7367f0"
                        strokeWidth="2"
                      />
                      Property document
                    </p>
                    <p className="cursor-pointer" onClick={downloadPDF}>
                      <DownloadIcon
                        width={22}
                        height={22}
                        color="#7367f0"
                        strokeWidth="2"
                      />
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>

          <Col xl={12} xxl={4}>
            <div className="grid column-gap-4 column-gap-xxl-0">
              <Card className="rounded-2 g-col-12 g-col-lg-6 g-col-xxl-12 p-4 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <h5 className="fw-medium text-capitalize">Details</h5>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <div
                    className="d-flex align-items-center gap-2 text-decoration-none mb-4 card-profile"
                  >
                    <div className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-1 user-icon">
                      <span className="text-uppercase fw-normal">
                        <Image src={'/assets/images/npa-properties/avatar.png'} alt="Avatar" />
                      </span>
                    </div>

                    <div className="d-flex flex-column">
                      <h6 className="fw-medium ms-1 text-capitalize">
                        {details?.borrower_names
                          ? details?.borrower_names
                          : "-"}
                      </h6>
                      <p className="p-extra-light mx-1">Borrower Name</p>
                    </div>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-bottom">
                    <p className="p-extra-light mb-2">Property ID</p>
                    <p className="p-dark mb-2">
                      {details?.property_number_id
                        ? `#${details?.property_number_id}`
                        : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-bottom mt-2">
                    <p className="p-extra-light mb-2">Auction Type</p>
                    <p className="p-dark mb-2">
                      {details?.auction_type ? details?.auction_type?.name : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-bottom mt-2">
                    <p className="p-extra-light mb-2">Possession Type</p>
                    <p className="p-dark mb-2">
                      {details?.possession_type
                        ? details?.possession_type?.name
                        : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between mt-2">
                    <p className="p-extra-light mb-2">DSC Required</p>
                    <p className="p-dark mb-2">
                      {details?.dsc_required
                        && details?.dsc_required === true
                        ? "Yes"
                        : details?.dsc_required === false
                          ? "No"
                          : "-"
                      }
                    </p>
                  </div>
                </Card.Body>
              </Card>

              <Card className="rounded-2 g-col-12 g-col-lg-6 g-col-xxl-12 p-4 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <h5 className="fw-medium text-capitalize">Area</h5>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2">
                    <div className="g-col-12 g-col-xl-6">
                      <div className="d-flex align-items-center status-content primary-status">
                        <i className="rounded-5 d-flex align-items-center justify-content-center status-icon primary">
                          <LandAreaIcon
                            size={22} />
                        </i>
                        <div>
                          <h6 className="npa-details">
                            {/* 43,560 sq ft */}
                            {details?.land_area
                              ? `${formatCurrencyIndianStyle(
                                details?.land_area
                              )} sq ft`
                              : ""}
                          </h6>
                          <span className="text-capitalize">Land Area</span>
                        </div>
                      </div>
                    </div>
                    <div className="g-col-12 g-col-xl-6">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className="rounded-5 d-flex align-items-center justify-content-center status-icon primary">
                          <CarpetAreaIcon
                            size={22}
                          />
                        </div>
                        <div>
                          <h6 className="npa-details">
                            {/* 1,500 sq ft */}
                            {details?.carpet_area
                              ? `${formatCurrencyIndianStyle(
                                details?.carpet_area
                              )} sq ft`
                              : ""}
                          </h6>
                          <span className="text-capitalize">Carpet Area</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <Card className="rounded-2 g-col-12 g-col-lg-6 g-col-xxl-12 p-4 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <h5 className="fw-medium text-capitalize">
                      Property Inspection
                    </h5>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2">
                    <div className="g-col-12 g-col-xl-6">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className="rounded-5 d-flex align-items-center justify-content-center status-icon">
                          <CalendarIcon
                            width={22}
                            height={22}
                            color="#9F2F48"
                            strokeWidth="1.5"
                          />
                        </div>
                        <div>
                          <h6 className="npa-details">
                            {details?.property_inspection_date
                              ? formatMomentDate(
                                details?.property_inspection_date
                              , "DD-MM-YYYY")
                              : "-"}
                          </h6>
                          <span className="text-capitalize">
                            Inspection Date
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="g-col-12 g-col-xl-6">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className="rounded-5 d-flex align-items-center justify-content-center status-icon primary">
                          <Clock05Icon size={22} />
                        </div>
                        <div>
                          <h6 className="npa-details">
                            {details?.property_inspection_date
                              ? formatMomentDate(
                                details?.property_inspection_date
                              , "hh:mm A")
                              : "-"}
                          </h6>
                          <span className="text-capitalize">
                            Inspection Time
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <Card className="rounded-2 g-col-12 g-col-lg-6 g-col-xxl-12 p-4 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <h5 className="fw-medium text-capitalize">
                      Application Submission
                    </h5>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <div className="grid row-gap-3 column-gap-0 column-gap-xxl-2">
                    <div className="g-col-12 g-col-xl-6">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className="rounded-5 d-flex align-items-center justify-content-center status-icon">
                          <CalendarIcon
                            width={22}
                            height={22}
                            color="#9F2F48"
                            strokeWidth="1.5"
                          />
                        </div>
                        <div>
                          <h6 className="npa-details">
                            {details?.application_submission_date
                              ? formatMomentDate(
                                details?.application_submission_date
                              , "DD-MM-YYYY")
                              : "-"}
                          </h6>
                          <span className="text-capitalize">
                            Submissions Date
                          </span>
                        </div>
                      </div>
                    </div>
                    <div className="g-col-12 g-col-xl-6">
                      <div className="d-flex align-items-center status-content primary-status">
                        <div className="rounded-5 d-flex align-items-center justify-content-center status-icon primary">
                          <Clock05Icon size={22} />
                        </div>
                        <div>
                          <h6 className="npa-details">
                            {details?.application_submission_date
                              ? formatMomentDate(
                                details?.application_submission_date
                              , "hh:mm A")
                              : "-"}
                          </h6>
                          <span className="text-capitalize">
                            Submissions Time
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Card.Body>
              </Card>

              <Card className="rounded-2 g-col-12  p-4 border-0 common-shadow w-100 common-card">
                <Card.Header className="px-0 pt-0 pb-4 bg-transparent border-0 common-card-header">
                  <div className="d-flex justify-content-between align-items-center gap-3 address-mb">
                    <h5 className="fw-medium text-capitalize">Address</h5>
                  </div>
                </Card.Header>
                <Card.Body className="p-0 common-card-body">
                  <div>
                    <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14874.616504626927!2d72.87209981497662!3d21.245559737334933!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be04f4fb5c0b087%3A0xb7aabd8a90da0679!2sMota%20Varachha%2C%20Surat%2C%20Gujarat!5e0!3m2!1sen!2sin!4v1733745823143!5m2!1sen!2sin"
                      width="100%"
                      height="125"
                      title="map"
                      style={{
                        borderRadius: "10px"
                      }}
                      allowFullScreen
                      loading="lazy"
                      referrerPolicy="no-referrer-when-downgrade"></iframe>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-bottom mb-2 mt-2">
                    <p className="p-extra-light mb-2">Province/State</p>
                    <p className="p-dark mb-2">
                      {details?.state ? details?.state : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-bottom mb-2">
                    <p className="p-extra-light mb-2">Taluka</p>
                    <p className="p-dark mb-2">
                      {details?.taluka ? details?.taluka : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between border-bottom mb-2">
                    <p className="p-extra-light mb-2">City/Town</p>
                    <p className="p-dark mb-2">
                      {details?.city ? details?.city : "-"}
                    </p>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <p className="p-extra-light">Area/locality</p>
                    <p className="p-dark">
                      {details?.area_locality ? details?.area_locality : "-"}
                    </p>
                  </div>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default ViewNpaProperties;
